import http from '../api/axios';

export const getIndexList = () => {
    return http.post('/api/index/index');
};
export const getCategoryList = (params) => {
    return http.get('/api/article/articlelist',{params});
};
export const getArticle = (params) => {
    return http.get('/api/article/article',{params});
};
export const getCategoryName = (params) => {
    return http.get('/api/article/category',{params});
};
export const getLotteryResult = (params) => {
    return http.get('/api/index/lotteryResult',{params});
};
export const getResultList = (params) => {
    return http.get('/api/index/resultList',{params});
};
export const getVideoName = () => {
    return http.post('/api/hotvideo/category');
}
export const getVideoList = (params) => {
    return http.post('/api/hotvideo/videoList',params);
}
export const getMatchList = (params) => {
    return http.post('/api/matchs/football_data',params);
}
export const getLiveStream = (params) => {
    return http.post('/api/index/streamInfo',params);
}
// export const getExpertList = (params) => {
//     return http.post('/api/expert/lotteryExpertList',params);
// }
// export const getExpertInfo = (params) => {
//     return http.post('/api/expert/expertInfo',params);
// }



// WEBPACK FOOTER //
// ./src/api/index.js